import CustomCard from "../../styleComp/CustomCard";
import { Typography, Button, Drawer, List, ListItem, ListItemIcon, ListItemText, Divider } from "@mui/material";
import logger from "../../utilitis/logger";
import Box from "@mui/material/Box";
import SearchIcon from "@mui/icons-material/Search";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { RolesContext } from "../../context/User";

const TwoInfoCard = ({ colorCard }) => {
  const [hover, setHover] = useState(false);
  const [hover2, setHover2] = useState(false);
  const [dataResponse, setdataResponse] = useState({});
  const [moneyResponse, setMoneyResponse] = useState({});
  const [stateroles, dispatchroles] = useContext(RolesContext);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();

  const TypographyStyle = {
    fontFamily: "'Varela Round', sans-serif",
  };
  
  const navigationPage = (selectedValue) => {
    navigate(`/${selectedValue}`);
    setDrawerOpen(false);
  };

  const handleCard1Click = () => {
    if (stateroles.roles.includes("linkopeninvoice") || stateroles.roles.includes("admin")) {
      navigationPage("linkopeninvoice");
    } else {
      setDrawerOpen(true);
    }
  };

  const handleCard2Click = () => {
    if (stateroles.roles.includes("getinvoice") || stateroles.roles.includes("admin")) {
      navigationPage("getinvoice");
    } else {
      setDrawerOpen(true);
    }
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await axios.get(
          "openInvoices/openInvoicesSummaryDetails",
          {
            withCredentials: true,
          }
        );
        let response_data = response.data;
        setdataResponse(response_data);
      } catch (error) {
        logger.error(error);
      }
    }

    async function fetchMoney() {
      try {
        const response = await axios.get("monthlyPay/payment_by_direct_debit", {
          withCredentials: true,
        });
        let response_data = response.data;
        setMoneyResponse(response_data.monthlyPay);
      } catch (error) {
        logger.error(error);
      }
    }
    fetchData();
    fetchMoney();
  }, []);

  return (
    <>
      <CustomCard
        heightCard={"15vh"}
        backgroundColorStyle={
          colorCard ? colorCard : hover ? "rgb(245,245,245)" : "white"
        }
      >
        {/* -----------------------------------------CARD 1 display XL------------------------------------------- */}

        <Box
          sx={{ display: { xs: "flex", md: "none", xl: "flex" } }}
          alignItems="center"
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          onClick={handleCard1Click}
        >
          {stateroles.roles.includes("linkopeninvoice") ||
          stateroles.roles.includes("admin") ? (
            <>
              {!hover ? (
                <>
                  <Box>
                    <Typography variant="h5" style={TypographyStyle}>
                      חשבוניות לתשלום
                    </Typography>
                    {Object.keys(dataResponse).length > 0 ? (
                      <>
                        <Typography style={TypographyStyle}>
                          מספר חשבוניות: {dataResponse.amount}
                        </Typography>
                        <Typography style={TypographyStyle}>
                          לתשלום:
                          <span
                            style={{ fontWeight: "bold", marginRight: "4px" }}
                          >
                            {dataResponse.totalSum < 0
                              ? ` ${parseFloat(
                                  Math.abs(dataResponse.totalSum)
                                ).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}- `
                              : ` ${parseFloat(
                                  dataResponse.totalSum
                                ).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}`}
                          </span>
                        </Typography>
                      </>
                    ) : (
                      <Typography variant="subtitle2" sx={{ color: "red" }}>
                        אין חשבונות לתשלום
                      </Typography>
                    )}
                  </Box>
                  {Object.keys(dataResponse).length > 0 ? (
                    <Box
                      sx={{ marginLeft: "1rem", marginTop: "1rem" }}
                      textAlign="center"
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                    >
                      <Typography
                        style={{
                          color: "red",
                          fontWeight: "bold",
                        }}
                        variant="h5"
                      >
                        {dataResponse.highestLagDays}
                      </Typography>
                      <Typography
                        style={{
                          color: "red",
                        }}
                      >
                        ימי פיגור
                      </Typography>
                    </Box>
                  ) : null}
                </>
              ) : (
                <div style={{ position: "relative" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => navigationPage("linkopeninvoice")}
                    style={{
                      position: "absolute",
                      top: 35,
                      left: "30%",
                      transform: "translateX(-50%)",
                      zIndex: 1,
                    }}
                  >
                    חשבוניות
                  </Button>
                  <Box style={{ filter: "blur(4px)", flex: 1 }}>
                    <Typography variant="h5" style={TypographyStyle}>
                      חשבוניות לשתלום
                    </Typography>
                    <Typography style={TypographyStyle}>
                      מספר חשבוניות: {dataResponse.amount}
                    </Typography>
                    <Typography style={TypographyStyle}>
                      לתשלום:
                      <span style={{ fontWeight: "bold", marginRight: "4px" }}>
                        {dataResponse.totalSum < 0
                          ? ` ${parseFloat(
                              Math.abs(dataResponse.totalSum)
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}- `
                          : ` ${parseFloat(
                              dataResponse.totalSum
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}`}
                      </span>
                    </Typography>
                  </Box>
                </div>
              )}
            </>
          ) : null}
        </Box>

        {/*----------------------------------------------- CARD 1 display MD --------------------------------------------*/}
        <Box
          sx={{ display: { xs: "none", md: "flex", xl: "none" } }}
          alignItems="center"
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          onClick={handleCard1Click}
        >
          {stateroles.roles.includes("linkopeninvoice") ||
          stateroles.roles.includes("admin") ? (
            <>
              {!hover ? (
                <>
                  <Box>
                    <Typography variant="subtitle1" style={TypographyStyle}>
                      לתשלום
                    </Typography>
                    {Object.keys(dataResponse).length > 0 ? (
                      <>
                        <Typography variant="caption" style={TypographyStyle}>
                          מספר חשבוניות: {dataResponse.amount}
                        </Typography>
                        <br />
                        <Typography variant="caption" style={TypographyStyle}>
                          לתשלום:
                          <span
                            style={{ fontWeight: "bold", marginRight: "4px" }}
                          >
                            {`${parseFloat(
                              dataResponse.totalSum
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })} `}
                          </span>
                        </Typography>
                      </>
                    ) : (
                      <Typography variant="subtitle2" sx={{ color: "red" }}>
                        אין חשבונות לתשלום
                      </Typography>
                    )}
                  </Box>
                </>
              ) : (
                <div style={{ position: "relative" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => navigationPage("linkopeninvoice")}
                    style={{
                      position: "absolute",
                      top: 15,
                      left: "40%",
                      transform: "translateX(-50%)",
                      zIndex: 1,
                    }}
                  >
                    חשבוניות
                  </Button>
                  <Box style={{ filter: "blur(4px)", flex: 1 }}>
                    <Typography variant="subtitle1" style={TypographyStyle}>
                      לתשלום
                    </Typography>
                    {Object.keys(dataResponse).length > 0 ? (
                      <>
                        <Typography variant="caption" style={TypographyStyle}>
                          מספר חשבוניות: {dataResponse.amount}
                        </Typography>
                        <br />
                        <Typography variant="caption" style={TypographyStyle}>
                          לתשלום:
                          <span
                            style={{ fontWeight: "bold", marginRight: "4px" }}
                          >
                            {`${parseFloat(
                              dataResponse.totalSum
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })} `}
                          </span>
                        </Typography>
                      </>
                    ) : (
                      <Typography variant="subtitle2" sx={{ color: "red" }}>
                        אין חשבונות לתשלום
                      </Typography>
                    )}
                  </Box>
                </div>
              )}
            </>
          ) : (
            <Box 
              sx={{ 
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                cursor: 'pointer'
              }}
            >
              <SearchIcon 
                sx={{ 
                  fontSize: 35, 
                  color: hover ? 'primary.main' : 'action.disabled',
                  transition: 'all 0.3s'
                }} 
              />
            </Box>
          )}
        </Box>
        <br />
      </CustomCard>
      
      <div style={{ marginTop: "0.7rem" }}></div>

      {/* ----------------------------------------- CARD 2 - הוראת קבע ----------------------------------------- */}
      <CustomCard
        heightCard={"15vh"}
        backgroundColorStyle={
          colorCard ? colorCard : hover2 ? "rgb(245,245,245)" : "white"
        }
      >
        {/* CARD 2 display XL */}
        <Box
          sx={{ display: { xs: "flex", md: "none", xl: "flex" } }}
          alignItems="center"
          onMouseEnter={() => setHover2(true)}
          onMouseLeave={() => setHover2(false)}
          onClick={handleCard2Click}
        >
          {stateroles.roles.includes("getinvoice") ||
          stateroles.roles.includes("admin") ? (
            <>
              {!hover2 ? (
                <>
                  <Box>
                    <Typography variant="h5" style={TypographyStyle}>
                      הוראת קבע
                    </Typography>
                    {moneyResponse?.errorDescription === "" ? (
                      <>
                        <Typography style={TypographyStyle}>
                          סכום: {moneyResponse["TOTPRICE"]}{" "}
                          {moneyResponse["CODE"]}
                        </Typography>
                        <Typography style={TypographyStyle}>
                          תאריך:
                          {moneyResponse["PAYDATE"]
                            ? moneyResponse["PAYDATE"].replace(
                                "T00:00:00+02:00",
                                ""
                              )
                            : null}
                        </Typography>
                      </>
                    ) : (
                      <Typography variant="subtitle2" sx={{ color: "red" }}>
                        אין הוראת קבע
                      </Typography>
                    )}
                  </Box>
                </>
              ) : (
                <div style={{ position: "relative" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => navigationPage("getinvoice")}
                    style={{
                      position: "absolute",
                      top: 35,
                      left: "30%",
                      transform: "translateX(-50%)",
                      zIndex: 1,
                    }}
                  >
                    חשבוניות וקבלות
                  </Button>
                  <Box style={{ filter: "blur(4px)", flex: 1 }}>
                    <Typography variant="h5" style={TypographyStyle}>
                      הוראת קבע
                    </Typography>
                    <Typography style={TypographyStyle}>
                      סכום: {moneyResponse?.["TOTPRICE"]} {moneyResponse?.["CODE"]}
                    </Typography>
                    <Typography style={TypographyStyle}>
                      תאריך:{" "}
                      {moneyResponse?.["PAYDATE"]
                        ? moneyResponse["PAYDATE"].replace(
                            "T00:00:00+02:00",
                            ""
                          )
                        : null}
                    </Typography>
                  </Box>
                </div>
              )}
            </>
          ) : (
            <Box 
              sx={{ 
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                cursor: 'pointer'
              }}
            >
              <InfoIcon 
                sx={{ 
                  fontSize: 50, 
                  color: hover2 ? 'primary.main' : 'action.disabled',
                  transition: 'all 0.3s'
                }} 
              />
              <Typography 
                variant="h6" 
                style={TypographyStyle}
                sx={{ mt: 1, color: hover2 ? 'primary.main' : 'text.primary', transition: 'all 0.3s' }}
              >
                מידע נוסף
              </Typography>
              <Typography variant="caption" color="text.secondary">
                לחץ למידע נוסף
              </Typography>
            </Box>
          )}
        </Box>

        {/* CARD 2 display MD */}
        <Box
          sx={{ display: { xs: "none", md: "flex", xl: "none" } }}
          alignItems="center"
          onMouseEnter={() => setHover2(true)}
          onMouseLeave={() => setHover2(false)}
          onClick={handleCard2Click}
        >
          {stateroles.roles.includes("getinvoice") ||
          stateroles.roles.includes("admin") ? (
            <>
              {!hover2 ? (
                <>
                  <Box>
                    <Typography variant="subtitle1" style={TypographyStyle}>
                      הוראת קבע
                    </Typography>
                    {moneyResponse?.errorDescription === "" ? (
                      <>
                        <Typography variant="caption" style={TypographyStyle}>
                          סכום: {moneyResponse["TOTPRICE"]}{" "}
                          {moneyResponse["CODE"]}
                        </Typography>
                        <br />
                        <Typography variant="caption" style={TypographyStyle}>
                          תאריך:{" "}
                          {moneyResponse["PAYDATE"]
                            ? moneyResponse["PAYDATE"].replace(
                                "T00:00:00+02:00",
                                ""
                              )
                            : null}
                        </Typography>
                      </>
                    ) : (
                      <Typography variant="subtitle2" sx={{ color: "red" }}>
                        אין הוראת קבע
                      </Typography>
                    )}
                  </Box>
                </>
              ) : (
                <div style={{ position: "relative" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => navigationPage("getinvoice")}
                    style={{
                      position: "absolute",
                      top: 15,
                      left: "30%",
                      transform: "translateX(-50%)",
                      zIndex: 1,
                    }}
                  >
                    חשבוניות וקבלות
                  </Button>
                  <Box style={{ filter: "blur(4px)", flex: 1 }}>
                    <Typography variant="subtitle1" style={TypographyStyle}>
                      הוראת קבע
                    </Typography>
                    {moneyResponse?.errorDescription === "" ? (
                      <>
                        <Typography variant="caption" style={TypographyStyle}>
                          סכום: {moneyResponse["TOTPRICE"]}{" "}
                          {moneyResponse["CODE"]}
                        </Typography>
                        <br />
                        <Typography variant="caption" style={TypographyStyle}>
                          תאריך:
                          {moneyResponse["PAYDATE"]
                            ? moneyResponse["PAYDATE"].replace(
                                "T00:00:00+02:00",
                                ""
                              )
                            : null}
                        </Typography>
                      </>
                    ) : (
                      <Typography variant="subtitle2" sx={{ color: "red" }}>
                        אין הוראת קבע
                      </Typography>
                    )}
                  </Box>
                </div>
              )}
            </>
          ) : (
            <Box 
              sx={{ 
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                cursor: 'pointer'
              }}
            >
              <InfoIcon 
                sx={{ 
                  fontSize: 35, 
                  color: hover2 ? 'primary.main' : 'action.disabled',
                  transition: 'all 0.3s'
                }} 
              />
              <Typography 
                variant="subtitle2" 
                style={TypographyStyle}
                sx={{ mt: 0.5, color: hover2 ? 'primary.main' : 'text.primary', transition: 'all 0.3s' }}
              >
                מידע נוסף
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.65rem' }}>
                לחץ למידע
              </Typography>
            </Box>
          )}
        </Box>
        <br />
      </CustomCard>

      {/* Sidebar Drawer */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        sx={{
          '& .MuiDrawer-paper': {
            width: 320,
            backgroundColor: 'rgb(41,91,154)',
            color: 'white',
            padding: '2rem 0'
          }
        }}
      >
        <Box sx={{ position: 'relative', height: '100%' }}>
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            px: 3,
            mb: 3
          }}>
            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
              תפריט
            </Typography>
            <Button
              onClick={() => setDrawerOpen(false)}
              sx={{
                minWidth: 'auto',
                color: 'white',
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.1)',
                }
              }}
            >
              <CloseIcon />
            </Button>
          </Box>

          <Divider sx={{ backgroundColor: 'rgba(255,255,255,0.2)', mb: 3 }} />

          <List sx={{ px: 2 }}>
            <ListItem 
              button 
              onClick={() => navigationPage("about")}
              sx={{
                backgroundColor: 'rgba(255,255,255,0.1)',
                borderRadius: '12px',
                padding: '1rem 1.5rem',
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.2)',
                  transform: 'translateX(-5px)',
                },
                transition: 'all 0.3s ease'
              }}
            >
              <ListItemIcon>
                <InfoIcon sx={{ color: 'white', fontSize: 28 }} />
              </ListItemIcon>
              <ListItemText 
                primary="מידע נוסף" 
                primaryTypographyProps={{ 
                  style: { 
                    ...TypographyStyle, 
                    fontSize: '1.1rem',
                    fontWeight: 600
                  } 
                }}
              />
            </ListItem>
          </List>

          <Box sx={{ 
            position: 'absolute', 
            bottom: 20, 
            left: 0, 
            right: 0,
            textAlign: 'center',
            px: 3
          }}>
            <Divider sx={{ backgroundColor: 'rgba(255,255,255,0.2)', mb: 2 }} />
            <Typography variant="caption" sx={{ opacity: 0.7 }}>
              פורטל לקוחות ניאופרם
            </Typography>
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

export default TwoInfoCard;